import { Sparkles } from "lucide-react";

export default function AIBanner() {
  return (
    <div className="bg-gradient-to-r from-indigo-600 to-blue-600 rounded-2xl p-6 flex items-center justify-between gap-4 flex-wrap text-white">
      <div className="flex items-center gap-4">
        <div className="w-11 h-11 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
          <Sparkles className="w-5 h-5" />
        </div>
        <div>
          <p className="font-bold text-lg">AI Prototype Assistant</p>
          <p className="text-indigo-100 text-sm">
            Upload your CAD file and get instant cost estimates, machine
            recommendations and feasibility analysis.
          </p>
        </div>
      </div>
      <button className="bg-white text-indigo-700 font-semibold text-sm px-5 py-2.5 rounded-xl hover:bg-gray-100 transition shrink-0">
        Try AI Estimator
      </button>
    </div>
  );
}